"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noopParser = void 0;
const noopParser = () => ({
    data: new Uint8Array(),
    remainingAccounts: [],
});
exports.noopParser = noopParser;
//# sourceMappingURL=guardManifest.js.map